import { render } from "./OnhireComponent.vue?vue&type=template&id=1705d6e8"
import script from "./OnhireComponent.vue?vue&type=script&lang=js"
export * from "./OnhireComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__